/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable arrow-body-style */
/* eslint-disable no-script-url */
/* eslint-disable react/button-has-type */
import React from 'react';
import { useLocation } from 'react-router';
import './view.css'

const ViewBooking = () => {
  const location = useLocation();

  console.log(location?.state , 'location');

  const datas = location?.state?.listing;
  const users = location?.state?.user;

  return (
    <>
      <div className="container">
        <div className="main-body">
          <div className="row gutters-sm">
            <div className="col-md-12">
              <div className="card mb-3">
                <div className="card-body">
                  <div className="row" style={{ gap: '12px' }}>
                    <div className="row" style={{ gap: '12px' }}>
                      <h2 className="fw-bold">Booking Uers Details</h2>
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">First Name</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{users?.first_name}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Last Name</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{users?.last_name}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Email</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{users?.email}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Username</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{users?.username}</div>
                        </div>
                      </div>
                      <hr />
                    </div>
                    <div className="row" style={{ gap: '12px' }}>
                      <h2 className="fw-bold">Listings Details</h2>
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Type of Space</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.type_of_space}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Title</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.title}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Description</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.description}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Listing Type</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.listing_type}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">No of Bedroom</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.no_of_bedroom}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">No of Guest</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.no_of_guest}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">No of Bed</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.no_of_bed}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div className="width">
                          <h6 className="mb-0">No of Bathroom</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.no_of_bathroom}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div className="width">
                          <h6 className="mb-0">No of Room</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.no_of_room}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Size</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.size}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Unit of Measure</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.unit_of_measure}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Addi Info</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.addi_info}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Instant Booking</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.instant_booking}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Nightly</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.nightly}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Per</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.per}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Weekend</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.weekend}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Apply weekend Price</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.apply_weekend_price}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Weekly seven Plus</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.weekly_seven_plus}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Weekly Thirty Plus</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.weekly_thirty_plus}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Addi Guest</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.addi_guest}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Addi Guest Price</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.addi_guest_price}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">No of Addi Guest</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.no_of_addi_guest}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Clean Fee</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.clean_fee}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Clean Fee Daily</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.clean_fee_daily}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Clean Fee Per Stay</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.clean_fee_per_stay}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">City Fee</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.city_fee}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">City Fee Daily</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.city_fee_daily}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">City Fee Per Stay</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.city_fee_per_stay}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Security Deposit</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.security_deposit}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Tax</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.tax}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Amenities</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{JSON.parse?.(datas?.amenities)}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Facilities</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{JSON.parse?.(datas?.facilities)}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Address</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.address}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Apt Suite</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.apt_suite}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">City</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.city}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">State</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.state}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Zipcode</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.zipcode}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Area</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.area}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Country</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.country}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Cancellation Policy</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.cancellation_policy}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Min day Booking</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.min_day_booking}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Max day Booking</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.max_day_booking}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Check in After</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.check_in_after}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Check in Before</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.check_in_before}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Smoking Allowed</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.smoking_allowed}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Pet Allowed</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.pet_allowed}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Party Allowed</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.party_allowed}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Children Allowed</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.children_allowed}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">House rule Addi Info</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.house_rule_addi_info}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="col-sm-12 columns">
                        <div>
                          <h6 className="mb-0">Status</h6>
                        </div>
                        <div className="width">
                          <div className="col-sm-12 text-secondary">{datas?.status}</div>
                        </div>
                      </div>
                      <hr />
                      {datas?.listing_beds?.map((item, index) => {
                        return (
                          <>
                            <div className="col-sm-12 columns" key={index}>
                              <div>
                                <h6 className="mb-0">Listing Beds</h6>
                              </div>
                              <div className="width">
                                <div className="col-sm-12 text-secondary">{item?.name}</div>
                              </div>
                            </div>
                            <hr />
                          </>
                        );
                      })}
                      {datas?.listing_extra_service_prices?.map((item, index) => {
                        return (
                          <>
                            <div className="col-sm-12 columns" key={index}>
                              <div>
                                <h6 className="mb-0">Listing Extra Service Prices</h6>
                              </div>
                              <div className="width">
                                <div className="col-sm-12 text-secondary">{item?.name}</div>
                              </div>
                            </div>
                            <hr />
                          </>
                        );
                      })}
                      {datas?.listing_images?.map((item, index) => {
                        return (
                          <>
                            <div className="col-sm-12 columns" key={index}>
                              <div>
                                <h6 className="mb-0">Listing Images</h6>
                              </div>
                              <div className="width">
                                <div className="col-sm-12 text-secondary">
                                  <img src={item?.image} alt="Images" style={{ width: '80px' , height:'80px' , borderRadius:'50%' }} />
                                </div>
                              </div>
                            </div>
                            <hr />
                          </>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewBooking;
